import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ModalProps,
} from "@mui/material";
import { useIsMobileView } from "../../hooks/use-is-mobile-view";
import { CustomButton } from "../custom-button/custom-button";

type DeleteModalProps = {
  itemName: string;
  itemType: string;
  isOpen: boolean;
  loading: boolean;
  onClose: () => void | ModalProps["onClose"];
  onDelete: () => void;
};

export const DeleteModal: React.FC<DeleteModalProps> = ({
  itemName,
  itemType,
  isOpen,
  loading,
  onClose,
  onDelete,
}) => {
  const isMobile = useIsMobileView();

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth={"sm"}>
      <DialogTitle>Remove {itemType}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove {itemName} ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CustomButton
          disabled={loading}
          onClick={onClose}
          buttonType="secondary"
          size={isMobile ? "small" : "medium"}
        >
          Cancel
        </CustomButton>

        <Box>
          <CustomButton
            id="remove-button"
            size={isMobile ? "small" : "medium"}
            onClick={onDelete}
            isLoading={loading}
            buttonType="danger"
          >
            Remove
          </CustomButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
